import { createAction } from '@reduxjs/toolkit';

export const setLastOrderId = createAction('checkout/set_last_order_id');
export const clearCheckoutData = createAction('checkout/clear_checkout_data');
